// Environment configuration for frontend
// React uses REACT_APP_ prefix for custom environment variables

interface EnvironmentConfig {
  apiUrl: string;
  socketUrl: string;
  isProduction: boolean;
}

const config: EnvironmentConfig = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  socketUrl: process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001',
  isProduction: process.env.NODE_ENV === 'production',
};

export default config;